import { MaxWidthContent } from '~/components';
import { DeclarationForm } from './DeclarationForm';
import {
    ReviewInvestmentOption,
    ReviewPensionDetails,
    ReviewPersonalDetails,
    ReviewWithdrawal,
} from './ReviewApplicationCards';
import { ReviewDocuments } from './ReviewDocuments';

export const ReviewApplication = () => {
    return (
        <MaxWidthContent>
            <ReviewPersonalDetails />
            <ReviewPensionDetails />
            <ReviewWithdrawal />
            <ReviewInvestmentOption />
            <ReviewDocuments />
            <DeclarationForm />
        </MaxWidthContent>
    );
};
